import {DateTime, Info} from "luxon";

export function getMonthName (month)
{
	const monthNames = Info.months();

	return monthNames[month - 1];
}

export function getDaysInMonth (year, month)
{
	const date = DateTime.fromISO(year + '-' + month.toString().padStart(2, '0') + '-01');

	return date.daysInMonth;
}

export function inPast ({day, month, year})
{
	const date = DateTime.fromISO(year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0'));

	const now = DateTime.now();

	return getDateComparisonValue(date) < getDateComparisonValue(now);
}

export function getDateComparisonValue (dateTime)
{
	return parseInt(dateTime.toFormat('yLLdd'));
}

export function getDateTimeComparisonValue (dateTime)
{
	return parseInt(dateTime.toFormat('yLLddHHmm'));
}

export function getMonthYearComparisonValue (month, year)
{
	if (typeof month !== 'string')
	{
		month = month.toString();
	}

	if (typeof year !== 'string')
	{
		year = year.toString();
	}

	return parseInt(year + month.padStart(2, '0'));
}

export function getMonthYearLabel (dateTime)
{
	return getMonthName(dateTime.month) + ' ' + dateTime.year;
}

export function formatDate (date)
{
	return date.toFormat('dd.LL.y');
}
